<style scoped>
.mmuul li{
  list-style: none;
  display: block;
  padding: 2px;
  cursor: pointer;
  border:1px solid #fff;
  margin-bottom: 2px;
}
.mmuul li:hover{
  border:1px solid rgba(255, 165, 0, 0.5);
}
.mmuul li.active{
  border:1px solid orange;
  /*background-color: blueviolet;*/
  background-image: linear-gradient(to right,#e66465, #9198e5);
  color: #fff;
}
</style>

<template>
  <div >
    <Select
      v-model="value"
      filterable
      @on-change="change"
      :remote-method="remoteMethod2"
      :loading="loading2">
      <Option v-for="(option, index) in options2" :value="option.SP_ID" :key="option.SP_ID" :label="option.PP_NAME+' '+option.SP_ADDRESS+' '+option.SP_STIME">
        {{option.PP_NAME}}/{{option.SP_STIME}}/{{option.SP_ADDRESS}}
      </Option>
    </Select>
  </div>
</template>


<script>
export default {
  props:['value'],
  data(){
    return{
      loading2:false,
      options2:[],
      spid:0
    }
  },
  methods:{
    change(){
      this.$emit('input',this.value);
      this.$emit('on-change');
    },
    remoteMethod2 (query) {
      if (query !== '') {
        this.loading2 = true;
        let that = this;
        this.$axios.get('/api/field/querySonproject?spname='+query).then(function(rs){
          that.options2 = rs.data;
          that.loading2 = false;
        });

      } else {
        this.options2 = [];
      }
    }
  },
  created() {

  },

}
</script>



// WEBPACK FOOTER //
// src/components/common/Spselect.vue